<template>
	<div class="banner">
		<!-- 电脑端 -->
		<div class="hidden-xs-only">
			<div class="text-container">
				<p class="text-1">中国美术学院</p>
				<p class="text-2">CHINA ACADEMY OF ART</p>
				<p class="text-3">社会美术水平考级管理系统</p>
				<p class="text-3">官方网站</p>
			</div>
		</div>
		<!-- 移动端 -->
		<div class="hidden-sm-and-up">
			<!-- 登陆页显示logo -->
			<div class="Showimg" v-if="currentPage === 'login'">
				<img class="show-img" src="@/assets/images/show-img.png" alt />
				<p>中国美术学院美术考级</p>
				<p>管理系统-考生端</p>
			</div>
			<!-- 非登陆页显示导航 -->
			<sticky :zIndex="999" v-else>
				<div class="title-top">
					<span class="iconfont icon-left-copy" @click="$router.go(-1)" v-if="isShow"></span>
					{{$route.meta.title}}
				</div>
			</sticky>
		</div>
	</div>
</template>
<script>
import sticky from "./sticky";
export default {
	data() {
		return {
			name: "",
			breadList: []
		};
	},
	components: { sticky },
	created() {
		this.getBreadcrumb();
	},
	computed: {
		currentPage() {
			return this.$route.name;
		},
		isShow() {
			const tabbar = this.$store.state.tabbar.map(v => {
				return v.url;
			});
			const current = this.$route.path;

			if (tabbar.indexOf(current) > -1) {
				return false;
			}
			return true;
		}
	},
	methods: {
		getBreadcrumb() {
			this.breadList = [];
			this.name = this.$route.name;

			this.$route.matched.forEach(item => {
				item.name === "index"
					? (item.path = "/")
					: this.$route.path === item.path;
				this.breadList.push(item);
			});
		}
	},
	watch: {
		$route() {
			this.getBreadcrumb();
		}
	}
};
</script>
<style lang="scss" scoped>
.banner {
	.text-container {
		width: 100%;
		padding: 0 120px;
		position: relative;
		z-index: 1;
		color: #fff;
		background: url("~@/assets/images/banner.jpg");
		background-position: top center;
		height: 292px;
		overflow: hidden;
		p {
			white-space: nowrap;
		}
		.text-1 {
			font-size: 34px;
			margin-top: 80px;
		}
		.text-2 {
			font-size: 12px;
			letter-spacing: 3px;
			&::after {
				content: "";
				display: block;
				width: 53px;
				height: 1px;
				background-color: #fff;
				margin: 10px 0;
			}
		}
		.text-3 {
			font-size: 22px;
		}
	}
	.Showimg {
		text-align: center;
		margin-top: 3.25rem;
		margin-bottom: 2rem;
		.show-img {
			width: 50%;
			padding-bottom: 0.8rem;
		}
		p {
			font-size: 1.2rem;
		}
	}
	.title-top {
		background: #fff;
		font-size: 0.8rem;
		line-height: 2.1rem;
		color: #1e1e1e;
		display: block;
		width: 96%;
		height: 2.1rem;
		text-align: center;
		border-bottom: 2px solid #d8010f;
		color: #d8010f;
		// transition: all 0.3s;
		margin-left: 2%;
		position: relative;
		.icon-left-copy {
			position: absolute;
			left: 5px;
		}
	}
}
@media screen and (max-width: 768px) {
}
</style>
